import Image from 'next/future/image';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const DefaultWrapper = ({ children }: { children: JSX.Element }) => (
  <div
    className="mb-6 pb-1 sm:rounded-xl sm:pb-0"
    // eslint-disable-next-line react/forbid-dom-props
    style={{
      background:
        'linear-gradient(90deg, rgba(123,53,53,1) 0%, rgba(31,35,35,1) 40%, rgba(31,35,35,1) 100%)',
    }}
  >
    <div className="relative h-20 md:h-24 xl:h-28">
      <div className="absolute right-3 top-0 mb-5 h-full md:right-5">
        <Image
          src={getEdgeUrl(
            'images/hot-deals/spotlight/spotlight-background.png',
          )}
          alt="Hot Deals"
          height={300}
          width={800}
          className="h-full w-auto rounded-tl-xl object-cover object-right"
        />
      </div>
      <div className="relative mb-5 flex h-full justify-center sm:justify-start">
        <Image
          src={getEdgeUrl('images/hot-deals/spotlight/hot-deals.png')}
          alt="Hot Deals"
          height={300}
          width={500}
          className="h-full w-auto object-contain"
        />
      </div>
    </div>
    {children}
  </div>
);

export default DefaultWrapper;
